import axios, { create, AxiosError } from "axios";
import { apiHostUrl, apiTimeOutInMilli, maxRedirects } from "../../constants/constants";
import { setupInterceptorsTo } from "./Interceptor";
// import {httpAdapter} from "axios/lib/adapters/adapters";
// import {settle} from "axios/lib/core/settle";
// const httpAdapter = require("axios/lib/adapters/adapters.js")
// const settle = require("axios/lib/core/settle.js")

axios.defaults.withCredentials = true;

function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
        'Request failed with status code ' + response.status,
        [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
        response.config,
        response.request,
        response
    ));
  }
}
const customAdapter = config =>
    new Promise((resolve, reject) => {
      axios.getAdapter("xhr")(config).then(response => {
        if (response.request.responseURL.includes("/cchp-api/login") || response.request.status === 500)
        {
          response.status = 503;
        }
        settle(resolve, reject, response);
      }).catch(reject);
    })


/**
 * Configuration for the Axios instance.
 * @type {Object}
 * @property {string} baseURL - The base URL for all API requests.
 * @property {boolean} withCredentials - Flag indicating whether to include credentials (cookies, HTTP auth) with requests.
 * @property {AbortSignal} signal - The abort signal to abort requests if they exceed the timeout.
 * @property {number} timeout - The maximum number of milliseconds before the request times out.
 * @property {number} maxRedirects - The maximum number of redirects to follow.
 * @property {Function} validateStatus - Function to check if the HTTP status is valid for the request (status >= 200 and < 300).
 * @property {Function} onDownloadProgress - Function to monitor download progress for requests.
 * @property {Function} onUploadProgress - Function to monitor upload progress for requests.
 */
let config = {
  baseURL: apiHostUrl,
  signal: AbortSignal.timeout(apiTimeOutInMilli),
  timeout: apiTimeOutInMilli,
  maxRedirects: maxRedirects,
  validateStatus: status => (status >= 200 && status < 300) || status === 500 || status === 302,
  // onDownloadProgress: progressEvent => console.log(progressEvent),
  // onUploadProgress: progressEvent => console.log(progressEvent),
  adapter:customAdapter
};


/**
 * Axios instance configured for backend API communication.
 * @type {AxiosInstance}
 * @description Axios instance that will be used for making API requests to the backend server.
 */
let backendAxiosInstance = axios.create(config);

backendAxiosInstance = setupInterceptorsTo(backendAxiosInstance);

export { backendAxiosInstance };